<div class="ui vertical segment" style="padding: 40px;">
  <div style="display: flex; align-items: center; justify-content: space-between;">
    <h3 class="ui primary header">
      {{ modal.context.title }}
    </h3>
    <i class="link times icon" (click)="modal.deny(undefined)"></i>
  </div>
  
  <div class="content" style="margin-top: 40px;">
    <div class="ui basic center aligned segment">
      <p>{{ modal.context.question }}</p>
      <div class="buttons">
        <button class="ui basic primary button" (click)="modal.deny(undefined)">
          {{ modal.context.negativeText }}
        </button>
        <button class="ui primary button" (click)="modal.approve(undefined)" autofocus>
          {{ modal.context.positiveText }}
        </button>
      </div>
    </div>
  </div>
</div>